module.exports = __webpack_public_path__ + "img/17-doc-comentarios-lista.909652c8.png";